export default {
    name: "puzzle",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one step
            showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            props: {
                labelKey: 'editbreak.steps.puzzle.headline',
                // helpContent: <PollHeadlineToolTip/>,
                // helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.headline'}/></IntlProvider>
            }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: true,
            props: {
                labelKey: 'editbreak.steps.puzzle.intro_copy',
                // helpContent: <PollHeadlineToolTip/>,
                // helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.headline'}/></IntlProvider>
            }
        },
        // {
        //     type: 'contenteditable',
        //     name: 'bodyCopy',
        //     required: true,
        //     props: {
        //         labelKey: 'editbreak.steps.puzzle.body_copy',
        //         // helpContent: <PollHeadlineToolTip/>,
        //         // helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.headline'}/></IntlProvider>
        //     }
        // },
        {
            type: 'contenteditable',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
            required: true,
            props: {
                labelKey: 'editbreak.steps.puzzle.commentQuestion',
                // helpContent: <PollHeadlineToolTip/>,
                // helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.poll.headline'}/></IntlProvider>
            }
        },
        // {
        //     type: 'image',
        //     name: 'targetImageId',
        //     idFor: 'targetImage',
        //     required: true,
        //     props: {
        //         labelKey: 'editbreak.steps.puzzle.targetImageId',
        //         imageType: 'dragDropCardImage'
        //     }
        // },
        {
            type: 'image',
            name: 'imageId',
            idFor: 'image',
            required: true,
            props: {
                labelKey: 'editbreak.steps.puzzle.imageId',
                imageType: 'puzzle'
            }
        },
        // {
        //     type: 'number',
        //     name: 'rows',
        //     required: true,
        //     props: {
        //         labelKey: 'editbreak.steps.puzzle.rows',
        //         ...sizeProps
        //     }
        // },
        // {
        //     type: 'number',
        //     name: 'columns',
        //     required: true,
        //     props: {
        //         labelKey: 'editbreak.steps.puzzle.columns',
        //         ...sizeProps
        //     }
        // }
    ]
}


// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/puzzle.js